import React from 'react';
import { Menu as MNU, Edit as EDT, CheckCircle as CHK } from '@material-ui/icons';
import * as CustomIcons from '@material-ui/icons';
// import CheckIcon from '@material-ui/icons/Check';

import { ReactComponent as AL } from '../../images/icons/arrow-left.svg';
import { ReactComponent as AR } from '../../images/icons/arrow-right.svg';
import { ReactComponent as C } from '../../images/icons/cancel.svg';
import { ReactComponent as CTG } from '../../images/icons/category.svg';
import { ReactComponent as CL } from '../../images/icons/close.svg';
import { ReactComponent as CO } from '../../images/icons/contact-icon.svg';
import { ReactComponent as DT } from '../../images/icons/delete-text-icon.svg';
import { ReactComponent as D } from '../../images/icons/delete.svg';
import { ReactComponent as DO } from '../../images/icons/down.svg';
import { ReactComponent as DL } from '../../images/icons/download.svg';
import { ReactComponent as H } from '../../images/icons/help.svg';
import { ReactComponent as L } from '../../images/icons/left.svg';
import { ReactComponent as LO } from '../../images/icons/logout.svg';
import { ReactComponent as M } from '../../images/icons/mail.svg';
import { ReactComponent as MPP } from '../../images/icons/menu-post-published.svg';
import { ReactComponent as MCTG } from '../../images/icons/menu-category.svg';
import { ReactComponent as MCH } from '../../images/icons/menu-chat.svg';
import { ReactComponent as MC } from '../../images/icons/menu-contacts.svg';
import { ReactComponent as MD } from '../../images/icons/menu-post-draft.svg';
import { ReactComponent as MPN } from '../../images/icons/menu-post-new.svg';

import { ReactComponent as ROOM } from '../../images/icons/accexxi.svg';
import { ReactComponent as POSTS } from '../../images/icons/posts.svg';
import { ReactComponent as SUB } from '../../images/icons/subscription.svg';
import { ReactComponent as ACC } from '../../images/icons/ingressi.svg';
import { ReactComponent as RSRV } from '../../images/icons/prenotazioni.svg';
import { ReactComponent as ACTMNU } from '../../images/icons/activities.svg';
import { ReactComponent as CAKE } from '../../images/icons/birthday-cake.svg';

import { ReactComponent as MSGMNU } from '../../images/icons/message-icon.svg';
import { ReactComponent as TR } from '../../images/icons/trainer-icon.svg';
import { ReactComponent as REM } from '../../images/icons/reminder-icon.svg';
import { ReactComponent as MEX } from '../../images/icons/reminder-icon.svg';
import { ReactComponent as MSG } from '../../images/icons/message-icon.svg';
import { ReactComponent as MN } from '../../images/icons/minus.svg';
import { ReactComponent as PL } from '../../images/icons/plus.svg';
import { ReactComponent as PR } from '../../images/icons/print.svg';
import { ReactComponent as PRV } from '../../images/icons/privacy.svg';
import { ReactComponent as R } from '../../images/icons/right.svg';
import { ReactComponent as S } from '../../images/icons/save.svg';
import { ReactComponent as UP } from '../../images/icons/up.svg';
import LogoImgUri from '../../images/icons/logo.png';

//const TextSvg = (props)=> <img className='svgIcon' style={props.style}>{MenuContacts}</img>
const WithClassName = (Comp) => (props) => {
    const { className, ...otherProps } = props;
    return <Comp className={'svgIcon '.concat(className)} {...otherProps} />
}

export const MenuContacts = WithClassName(MC);
export const MenuTrainers = WithClassName(TR);
export const MenuReminders = WithClassName(REM);
export const MenuMedicalExaminations = WithClassName(MEX);
export const ArrowLeft = WithClassName(AL);
export const ArrowRight = WithClassName(AR);
export const Cancel = WithClassName(C);
export const Category = WithClassName(CTG);
export const Close = WithClassName(CL);
export const Contact = WithClassName(CO);
export const DeleteText = WithClassName(DT);
export const Delete = WithClassName(D);
export const Down = WithClassName(DO);
export const Download = WithClassName(DL);
export const Help = WithClassName(H);
export const Left = WithClassName(L);
export const Logout = WithClassName(LO);
export const Mail = WithClassName(M);
export const MenuPostPublished = WithClassName(MPP);
export const MenuCategory = WithClassName(MCTG);
export const MenuChat = WithClassName(MCH);
export const MenuDraft = WithClassName(MD);
export const MenuPostNew = WithClassName(MPN);

export const MenuRoom = WithClassName(ROOM);
export const MenuPosts = WithClassName(POSTS);
export const MenuSubscriptions = WithClassName(SUB);
export const MenuReservation = WithClassName(RSRV);
export const MenuActivities = WithClassName(ACTMNU);
export const MenuBirthday = WithClassName(CAKE);
export const MenuAccesses = WithClassName(ACC);

export const Message = WithClassName(MSG);
export const MessageMenu = WithClassName(MSGMNU);
export const Minus = WithClassName(MN);
export const Plus = WithClassName(PL);
export const Print = WithClassName(PR);
export const Privacy = WithClassName(PRV);
export const Right = WithClassName(R);
export const Save = WithClassName(S);
export const Up = WithClassName(UP);
export const Menu = WithClassName(MNU);
export const Edit = WithClassName(EDT);
export const Check = WithClassName(CHK);
// Crava - In attesa del vero logo svg
export const LogoImg = WithClassName((props) => <img alt='area ferrero' src={LogoImgUri} {...props} />)
export const MuiIcons = CustomIcons;

